import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';
import {VasatModule} from 'vasat-ng';

import { MainComponent } from './main.component';
import { MapDataService } from '../commons/map-data.service';

import { MatSidenavModule } from '@angular/material';
import { DetailsComponent } from './child_routes/details.component';
import { MapEventService } from '../commons/map-event.service';
import { FourDMapComponent } from '../commons/cesium/cesium-map-viewer.component';
import { ProjectPickerComponent } from './project_picker.component';
import { UploadComponent } from './child_routes/upload.component';
import { FdmFilesModule } from '../commons/files/files.module';

const Routes: Routes = [
  {
    path: '', component: ProjectPickerComponent
  },
   {
    path: ':projId/:sceneId/:tabId', component: MainComponent,
    children: [
      {path: 'upload', component: UploadComponent},
      {path: ':objType/:layerId', component: DetailsComponent},
      {path: ':objType/:layerId/jump/:jump', component: DetailsComponent}
     
      //{path: '**', component: TBAComponent}
    ]
  }
];

@NgModule({
  imports: [
    FormsModule,
    VasatModule,
    FdmFilesModule,
    CommonModule,
    MatSidenavModule,
    RouterModule.forChild(Routes)
  ],
  declarations: [
    MainComponent,FourDMapComponent, DetailsComponent,ProjectPickerComponent,UploadComponent
  ],
  providers:[
    MapEventService
  ],
  entryComponents: []

})

export class ProjectMapModule {


}
